import common from "@/config/common";
const accessTokenKey = "access_token";
const refreshTokenKey = "refresh_token";
const participantToken = "ParticipantToken";
const mfaToken = "MFAToken";
const challengeToken = "ChallengeToken";
const resetPasswordToken = "ResetPasswordToken";

function getToken(tokenName: string) {
  return sessionStorage.getItem(tokenName);
}

function setToken(tokenName: string, token: string) {
  sessionStorage.setItem(tokenName, token);
}

function removeToken(tokenName: string) {
  sessionStorage.removeItem(tokenName);
}

function getAccessToken() {
  return sessionStorage.getItem(accessTokenKey);
}

function setAccessToken(token: string) {
  sessionStorage.setItem(accessTokenKey, token);
}

function removeAccessToken() {
  sessionStorage.removeItem(accessTokenKey);
}

function getAccessTokenExpiry() {
  return sessionStorage.getItem(common.storageVariables.accessTokenExpiry);
}

function setAccessTokenExpiry(date: string) {
  sessionStorage.setItem(common.storageVariables.accessTokenExpiry, date);
}

function removeAccessTokenExpiry() {
  sessionStorage.removeItem(common.storageVariables.accessTokenExpiry);
}

function isTokenExpired() {
  const accessToken = getAccessToken();
  if (!accessToken) {
    return true;
  }

  const tokenExpiryDate = getAccessTokenExpiry();
  if (!tokenExpiryDate) {
    return true;
  }

  const now = new Date();
  const expirationDate = new Date(tokenExpiryDate);

  return now > expirationDate;
}

function getRefreshToken() {
  return sessionStorage.getItem(refreshTokenKey);
}

function setRefreshToken(token: string) {
  sessionStorage.setItem(refreshTokenKey, token);
}

function removeRefreshToken() {
  sessionStorage.removeItem(refreshTokenKey);
}

function logout() {
  removeAccessToken();
  removeAccessTokenExpiry();
  removeRefreshToken();
  removeToken("ParticipantToken");
  removeToken("SearchParticantToken");
  sessionStorage.removeItem(common.storageVariables.applicationSubmitted);
  sessionStorage.removeItem(common.storageVariables.isSubmitted);
  sessionStorage.removeItem(common.storageVariables.pageStep);
  sessionStorage.removeItem(common.storageVariables.allBenefitsWaived);
  sessionStorage.removeItem(common.storageVariables.paymentMethod);
  sessionStorage.removeItem(common.storageVariables.otpTimer);
  sessionStorage.removeItem(common.storageVariables.loginData);
  sessionStorage.removeItem(common.storageVariables.enrollments);
  sessionStorage.removeItem(common.storageVariables.enrollment);
  sessionStorage.removeItem(common.storageVariables.mfaToken);
  sessionStorage.removeItem(
    common.storageVariables.wasSpecialOpenEnrollmentCreated
  );
}
const TokenService = {
  getAccessToken,
  setAccessToken,
  getAccessTokenExpiry,
  setAccessTokenExpiry,
  isTokenExpired,
  getRefreshToken,
  setRefreshToken,
  logout,
  getToken,
  setToken,
  removeToken,
};

export default TokenService;
